export var CheckoutProvider = {
  BT_CHECKOUT: 'bt-checkout',
  SHOPIFY_CHECKOUT: 'shopify-checkout',
  EXPERIMENT: 'experiment'
};